import { render, staticRenderFns } from "./CreateRuleModal.vue?vue&type=template&id=59bf75ec"
import script from "./CreateRuleModal.vue?vue&type=script&lang=js"
export * from "./CreateRuleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports